import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import Filter from 'components/Filter'
import Paper from 'components/Paper'
import { TableHeader, usePagination } from 'components/Table'
import { ReportsTable } from 'features/yieldbirdWrapperAgent/components/ReportsTable'

import type { FilterValue } from 'components/Filter'

export const ReportsSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/yieldbirdWrapperAgent', { keyPrefix: 'reports' })
  const [filters, setFilters] = useState<FilterValue[]>([])
  const pagination = usePagination()

  const handleFiltersChange = (values: FilterValue[]): void => {
    setFilters(values.slice(-1)) // API supports only one filter
    pagination.setPage(1)
  }

  const ReportsFilter = (
    <Filter
      id='reports-filter'
      onChange={handleFiltersChange}
      placeholder={t('filter')}
      values={filters}
    />
  )

  return (
    <Paper>
      <TableHeader
        description={t('description')}
        filter={ReportsFilter}
        title={t('title')}
      />

      <GapBox />

      <ReportsTable
        filters={filters}
        pagination={pagination}
      />
    </Paper>
  )
}
